// extracted by mini-css-extract-plugin
export default {"tooltip":"Yo-z","sharingV2":"Zo-z","sharingIconsV2":"_o-z","links":"ap-z","link":"bp-z","facebookV2":"cp-z","twitterV2":"dp-z","pinterestV2":"ep-z"};